import React, { useState, useEffect } from "react";
import axios from "axios";
import "./propertydetails.css";
import Header from "../../components/Navbar";
import Map from "../../myimgs/Group 27.png";
import Home from "../../myimgs/home1.png";
import BAD from "../../myimgs/bads.png";
import BATH from "../../myimgs/bath.png";
import Size from "../../myimgs/size.png";
import pdf from "../../myimgs/pdf.png";
import Slider from "../../components/slider/slider";
import Footer from "../../components/footer/footer";
import nodata from "../../myimgs/Group 232.png";
import Swal from "sweetalert2";
import socketService from "../../utils/socket";
import Loader from "../../components/Loader/loader";
import placeimg from "../../myimgs/Group 193.png";
import { Link } from "react-router-dom";

function PropertyDetail() {
  const hash = window.location.hash;
  // const propertyId = hash ? hash.replace("#", "") : null;
  const userId = localStorage.getItem("userId");
  const queryParams = new URLSearchParams(window.location.search);
  let propertyId = queryParams.get("id");
  let propeId = queryParams.get("propeId");

  // Agar URL mein 'id' ya 'propeId' nahi milti, toh localStorage se lene ki koshish karo
  if (!propertyId) {
    propertyId = localStorage.getItem("propertyId");
  }

  if (!propeId) {
    propeId = localStorage.getItem("propeId");
  }

  // Ab aapke paas 'propertyId' aur 'propeId' dono ho sakte hain, chahe wo URL se aaye ho ya localStorage se
  console.log(propertyId, propeId);

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupIndex, setPopupIndex] = useState(0);
  const [propertyData, setPropertyData] = useState(null);
  const [bid, setBid] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [mainImage, setMainImage] = useState(null);
  const [thumbImages, setThumbImages] = useState([]);
  const [liveBid, setLiveBid] = useState(null);

  useEffect(() => {
    if (!propertyData || !propertyData.id) return;

    socketService.getData((bidData) => {
      if (bidData.propertyId === propertyData.id) {
        setLiveBid(bidData.bidAmount);
      }
    });

    socketService.addErrorListener((errorMessage) => {
      console.error("Error from WebSocket:", errorMessage);
      alert(`Offer Error: ${errorMessage}`);
    });
  }, [propertyData]);

  useEffect(() => {
    const fetchPropertyDetails = async () => {
      if (!propertyId) {
        setError("Property ID not found in URL.");
        setLoading(false);
        return;
      }

      try {
        // Determine which API to call
        let apiUrl = "";

        if (!propeId || propeId === "null" || propeId === "") {
          apiUrl = `${baseUrl}/property/realtor-id/${propertyId}`;
          console.log("Using realtor-id API:", apiUrl);
        } else if (userId === "null" || !userId) {
          apiUrl = `${baseUrl}/property/${propertyId}`;
          console.log("Using property API without user-id:", apiUrl);
        } else {
          apiUrl = `${baseUrl}/property/${propertyId}/user-id/${userId}`;
          console.log("Using property API with user-id:", apiUrl);
        }

        const response = await axios.get(apiUrl);

        if (response.data.status === 200) {
          const data = response.data.data;
          setPropertyData(data);

          // Initialize bid
          if (data?.biddingDetails) {
            const { currenntAuctionAmount, bidStartingValue } =
              data.biddingDetails;
            const baseValue = currenntAuctionAmount ?? bidStartingValue ?? 0;
            setBid(baseValue);
          } else {
            setBid(data.desiredPropertyValue ?? 0);
          }

          // Logs
          console.log("Selected Property ID:", propertyId);
          console.log("Prope ID:", propeId);

          // Handle images
          if (data.propertyImages?.length > 0) {
            setMainImage(data.propertyImages[0].imageUrl);
            setThumbImages(data.propertyImages.slice(1));
          }
        } else {
          setError("Failed to fetch property details");
        }
      } catch (err) {
        console.error(err);
        setError("Error fetching property data");
      } finally {
        setLoading(false);
      }
    };
    fetchPropertyDetails();
  }, [propertyId, propeId, baseUrl]);

  const handleThumbClick = (imageUrl) => {
    if (!imageUrl) return;

    // Update the main image
    setMainImage(imageUrl);

    // Optional: If you want to swap the main image and clicked thumbnail
    const updatedThumbs = thumbImages.map((img) =>
      img.imageUrl === imageUrl ? { imageUrl: mainImage } : img
    );
    setThumbImages(updatedThumbs);
  };

  if (loading)
    return (
      <div className="loader-wrapper">
        <div className="loader"></div>
      </div>
    );

  if (error) return <div className="error">{error}</div>;
  if (!propertyData) return null;

  const {
    propertyName,
    propertyType,
    streetAddress,
    city,
    state,
    zipcode,
    country,
    propertySize,
    bedRooms,
    bathroms,
    halfBathrooms,
    marketingDescription,
    user,
    textDisclaimer,
    docDisclaimer,
    totalRooms,
  } = propertyData;
  // timersss  ...

  function Countdown({ start, end }) {
    const [timeLeft, setTimeLeft] = useState("");

    const formatDateTime = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      if (isNaN(date)) return "";
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}-${month}-${year}, ${hours}:${minutes}`;
    };

    const getRemainingTime = (startTime, endTime) => {
      if (!startTime || !endTime) return ""; // blank if missing

      const now = new Date();
      const startDate = new Date(startTime);
      const endDate = new Date(endTime);

      // Invalid date check
      if (isNaN(startDate) || isNaN(endDate)) return "";

      // Before Offer starts
      if (now < startDate) {
        return `Starts on ${formatDateTime(startDate)}`;
      }
      const diff = endDate - now;
      // After Offer Ended
      if (diff <= 0) {
        return "Offers Ended";
      }
      // While Offer is active
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
      return `${days}D : ${hours}H : ${minutes}M : ${seconds}s`;
    };

    useEffect(() => {
      const interval = setInterval(() => {
        const result = getRemainingTime(start, end);
        setTimeLeft(result);
      }, 1000);

      return () => clearInterval(interval);
    }, [start, end]);

    return (
      <h3>
        <span className="aucnt">Property Offer</span>
        <br />
        {timeLeft && timeLeft !== "Offer Ended"
          ? timeLeft
          : timeLeft === "Offer Ended"
          ? "Offer Ended"
          : ""}
      </h3>
    );
  }
  // timersss  ...
  return (
    <>
      <Header />
      <div className="property-detail-page scrolleffect">
        {/* Tabs */}
        <div className="tabs">
          <div className="btnflx">
            <button
              onClick={() =>
                document
                  .getElementById("Overview")
                  .scrollIntoView({ behavior: "smooth" })
              }
            >
              Overview
            </button>
            <button
              onClick={() =>
                document
                  .getElementById("PropertyDetails")
                  .scrollIntoView({ behavior: "smooth" })
              }
            >
              Property Details
            </button>

            <button
              onClick={() =>
                document
                  .getElementById("RecommendedProperties")
                  .scrollIntoView({ behavior: "smooth" })
              }
            >
              Recommended Properties
            </button>
          </div>
          <Link to="/booktours">
            <button className="booktour">Book a Tour</button>
          </Link>
        </div>

        <div className="main-section" id="Overview">
          {/* Left Gallery */}
          <div className="gallery-section">
            <div className="gallery-grid">
              {/* Left Big Image */}
              <div className="main-photo">
                <img
                  src={mainImage ? mainImage : placeimg}
                  alt="Main Property"
                />
              </div>

              {/* Right Thumbnail Grid */}
              <div className="side-thumbnails">
                {thumbImages && thumbImages.length > 0
                  ? thumbImages.slice(0, 4).map((img, index) => (
                      <div
                        key={index}
                        className="thumb-box"
                        onClick={() => {
                          if (index === 3 && thumbImages.length > 4) {
                            setIsPopupOpen(true);
                            setPopupIndex(3);
                          } else {
                            handleThumbClick(img?.imageUrl || placeimg);
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={img?.imageUrl ? img.imageUrl : placeimg}
                          alt={`Thumbnail ${index + 1}`}
                        />
                        {index === 3 && thumbImages.length > 4 && (
                          <div className="more-overlay">
                            +{thumbImages.length - 4} more
                          </div>
                        )}
                      </div>
                    ))
                  : Array(4)
                      .fill(0)
                      .map((_, i) => (
                        <div key={i} className="thumb-box">
                          <img src={placeimg} alt={`Placeholder ${i + 1}`} />
                        </div>
                      ))}
              </div>
            </div>
          </div>
        </div>

        {/* Property Info */}
        <div className="property-info contianer-fluid">
          <div className="row">
            <div className="col-md-8">
              <h2>{propertyName}</h2>
              <p className="pamp">
                <img src={Map} alt="" />
                {propertyData.unparsedAddress}
              </p>

              <div className="property-features" id="PropertyDetails">
                {/* Property Type */}
                {propertyData?.propertyType && (
                  <>
                    <div>
                      <img src={Home} alt="" />
                      <h5>Property Type</h5>
                      <h2>{propertyData.propertyType}</h2>
                    </div>
                    <strong></strong>
                  </>
                )}

                {/* Bedrooms */}
                {propertyData?.bedRooms && (
                  <>
                    <div>
                      <img src={BAD} alt="" />
                      <h5>Bedrooms</h5>
                      <h2>{propertyData.bedRooms}</h2>
                    </div>
                    <strong></strong>
                  </>
                )}

                {/* Bathrooms */}
                {propertyData?.bathroms && (
                  <>
                    <div>
                      <img src={BATH} alt="" />
                      <h5>Bathrooms</h5>
                      <h2>{propertyData.bathroms}</h2>
                    </div>
                    <strong></strong>
                  </>
                )}

                {/* Size */}
                {propertyData?.propertySize && (
                  <>
                    <div>
                      <img src={Size} alt="" />
                      <h5>Size</h5>
                      <h2>{propertyData.propertySize} ft²</h2>
                    </div>
                  </>
                )}
              </div>

              {/* <div className="address-details">
                <p>
                  <strong>Address:</strong> {propertyData.unparsedAddress}
                </p>
              </div> */}

              <div className="info-section container">
                <div className="row">
                  <div className="col-md-12" style={{ padding: "0" }}>
                    <div className="info-card bhfg info-cardsh">
                      {/* 1. Property Overview */}
                      <h5>1. Property Overview</h5>
                      <ul className="custom-list">
                        {propertyData?.listingKey && (
                          <li>
                            ListingKey:{" "}
                            <strong>{propertyData.listingKey}</strong>
                          </li>
                        )}

                        {propertyData?.propertySubType && (
                          <li>
                            Property Type:{" "}
                            <strong>{propertyData.propertySubType}</strong>
                          </li>
                        )}

                        {propertyData?.standardStatus && (
                          <li>
                            Standard Status:{" "}
                            <strong>{propertyData.standardStatus}</strong>
                          </li>
                        )}

                        {propertyData?.commonInterest && (
                          <li>
                            Common Interest:{" "}
                            <strong>{propertyData.commonInterest}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.structureType?.length > 0 && (
                          <li>
                            Building Type:{" "}
                            <strong>
                              {propertyData.structureType.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.propertyCondition?.length > 0 && (
                          <li>
                            Property Condition:{" "}
                            <strong>
                              {propertyData.propertyCondition.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.architecturalStyle?.length > 0 && (
                          <li>
                            Architectural Style:{" "}
                            <strong>
                              {propertyData.architecturalStyle.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.stories && (
                          <li>
                            Stories: <strong>{propertyData.stories}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.propertyAttachedYN !== null &&
                          propertyData?.propertyAttachedYN !== undefined && (
                            <li>
                              Property Attached:{" "}
                              <strong>
                                {String(propertyData.propertyAttachedYN)}
                              </strong>
                            </li>
                          )}

                        {propertyData?.yearBuilt && (
                          <li>
                            Year Built: <strong>{propertyData.yearBuilt}</strong>{" "}
                          </li>
                        )}
                      </ul>

                      {/* 2. Location Details */}
                      <h5>2. Location Details</h5>
                      <ul className="custom-list">
                        {propertyData?.unparsedAddress && (
                          <li>
                            Address:{" "}
                            <strong>{propertyData.unparsedAddress}</strong>
                          </li>
                        )}

                        {propertyData?.streetNumber && (
                          <li>
                            Street Number:{" "}
                            <strong>{propertyData.streetNumber}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.streetDirPrefix && (
                          <li>
                            StreetDirPrefix:{" "}
                            <strong>{propertyData.streetDirPrefix}</strong>
                          </li>
                        )}

                        {propertyData?.streetName && (
                          <li>
                            Street Name:{" "}
                            <strong> {propertyData.streetName}</strong>
                          </li>
                        )}

                        {propertyData?.streetSuffix && (
                          <li>
                            Street Suffix:{" "}
                            <strong>{propertyData.streetSuffix}</strong>
                          </li>
                        )}

                        {propertyData?.unitNumber && (
                          <li>
                            Unit Number:{" "}
                            <strong>{propertyData.unitNumber}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.city && (
                          <li>
                            City: <strong>{propertyData.city}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.cityRegion && (
                          <li>
                            City Region:{" "}
                            <strong>{propertyData.cityRegion}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.stateOrProvince && (
                          <li>
                            Province:{" "}
                            <strong>{propertyData.stateOrProvince}</strong>
                          </li>
                        )}

                        {propertyData?.postalCode && (
                          <li>
                            Postal Code:{" "}
                            <strong> {propertyData.postalCode}</strong>
                          </li>
                        )}

                        {propertyData?.country && (
                          <li>
                            Country: <strong>{propertyData.country}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.subdivisionName && (
                          <li>
                            Sub DIvision Name:{" "}
                            <strong>{propertyData.subdivisionName}</strong>
                          </li>
                        )}

                        {propertyData?.directions && (
                          <li>
                            Location Direction:{" "}
                            <strong>{propertyData.directions}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.municipality && (
                          <li>
                            Municipality:{" "}
                            <strong>{propertyData.municipality}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.latitude && (
                          <li>
                            Google Map Open: <strong> {propertyData.latitude}</strong>
                          </li>
                        )}

                        {propertyData?.longitude && (
                          <li>
                            Google Map Open: <strong>{propertyData.longitude}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.mapCoordinateVerifiedYN !== null &&
                          propertyData?.mapCoordinateVerifiedYN !==
                            undefined && (
                            <li>
                              MapCoordinateVerifiedYN:{" "}
                              <strong>
                                {String(propertyData.mapCoordinateVerifiedYN)}
                              </strong>
                            </li>
                          )}
                      </ul>

                      {/* 3. Price & Financial Info */}
                      <h5>3. Price & Financial Info</h5>
                      <ul className="custom-list">
                        {/* {propertyData?.listPrice && (
                          <li>
                            Desired Property Value:{" "}
                            <strong> {propertyData.listPrice}</strong>
                          </li>
                        )} */}

                        {propertyData?.leaseAmount && (
                          <li>
                            Lease Amount:{" "}
                            <strong> {propertyData.leaseAmount}</strong>
                          </li>
                        )}

                        {propertyData?.leaseAmountFrequency && (
                          <li>
                            Lease Amount Frequency:{" "}
                            <strong>{propertyData.leaseAmountFrequency}</strong>
                          </li>
                        )}

                        {propertyData?.pricePerUnit && (
                          <li>
                            Price Per Unit:{" "}
                            <strong> {propertyData.pricePerUnit}</strong>
                          </li>
                        )}

                        {propertyData?.leasePerUnit && (
                          <li>
                            Lease Per Unit:{" "}
                            <strong> {propertyData.leasePerUnit}</strong>
                          </li>
                        )}

                        {propertyData?.taxAnnualAmount && (
                          <li>
                            TaxAnnualAmount:{" "}
                            <strong> {propertyData.taxAnnualAmount}</strong>
                          </li>
                        )}

                        {propertyData?.taxYear && (
                          <li>
                            Tax Annual Amount: <strong> {propertyData.taxYear}</strong>
                          </li>
                        )}

                        {propertyData?.totalActualRent && (
                          <li>
                            Actual Rent:{" "}
                            <strong> {propertyData.totalActualRent}</strong>
                          </li>
                        )}

                        {propertyData?.offerStartingPrice && (
                          <li>
                            OfferStarting Price:{" "}
                            <strong>{propertyData.offerStartingPrice}</strong>
                          </li>
                        )}

                        {propertyData?.originalEntryTimestamp && (
                          <li>
                            OriginalEntry Timestamp:{" "}
                            <strong>
                              {propertyData.originalEntryTimestamp}
                            </strong>
                          </li>
                        )}

                        {propertyData?.statusChangeTimestamp && (
                          <li>
                            StatusChange Timestamp:{" "}
                            <strong>
                              {propertyData.statusChangeTimestamp}
                            </strong>
                          </li>
                        )}
                      </ul>

                      {/* 4. Home Features & Interior */}
                      <h5>4. Home Features & Interior</h5>
                      <ul className="custom-list">
                        {propertyData?.bedroomsTotal && (
                          <li>
                            Total Number Of Bedroom:{" "}
                            <strong>{propertyData.bedroomsTotal}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.bedroomsAboveGrade && (
                          <li>
                            Bedrooms Counts Above Grade:{" "}
                            <strong>{propertyData.bedroomsAboveGrade}</strong>
                          </li>
                        )}

                        {propertyData?.bedroomsBelowGrade && (
                          <li>
                            Bedrooms Counts Below Grade:{" "}
                            <strong>{propertyData.bedroomsBelowGrade}</strong>
                          </li>
                        )}

                        {propertyData?.bathroomsTotalInteger && (
                          <li>
                            Total Number Of Bathrooms:{" "}
                            <strong>
                              {propertyData.bathroomsTotalInteger}
                            </strong>
                          </li>
                        )}

                        {propertyData?.bathroomsPartial && (
                          <li>
                            Total Number of Half Bathrooms:{" "}
                            <strong>{propertyData.bathroomsPartial}</strong>
                          </li>
                        )}

                        {propertyData?.livingArea && (
                          <li>
                            Living Area:{" "}
                            <strong>{propertyData.livingArea}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.livingAreaUnits && (
                          <li>
                            Living Area Units:{" "}
                            <strong> {propertyData.livingAreaUnits}</strong>
                          </li>
                        )}

                        {propertyData?.livingAreaSource && (
                          <li>
                            Living Area Source:{" "}
                            <strong> {propertyData.livingAreaSource}</strong>
                          </li>
                        )}

                        {propertyData?.livingAreaMinimum && (
                          <li>
                            Living Area Minimum:{" "}
                            <strong> {propertyData.livingAreaMinimum}</strong>
                          </li>
                        )}

                        {propertyData?.livingAreaMaximum && (
                          <li>
                            Living Area Maximum:{" "}
                            <strong>{propertyData.livingAreaMaximum}</strong>
                          </li>
                        )}

                        {propertyData?.aboveGradeFinishedArea && (
                          <li>
                            AboveGrade Finished Area:{" "}
                            <strong>
                              {propertyData.aboveGradeFinishedArea}
                            </strong>
                          </li>
                        )}

                        {propertyData?.belowGradeFinishedArea && (
                          <li>
                            Below Grade Finished Area:{" "}
                            <strong>
                              {propertyData.belowGradeFinishedArea}
                            </strong>
                          </li>
                        )}

                        {propertyData?.basement?.length > 0 && (
                          <li>
                            Basement Available:{" "}
                            <strong>{propertyData.basement.join(", ")}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.flooring?.length > 0 && (
                          <li>
                            Flooring Type:{" "}
                            <strong> {propertyData.flooring.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.fireplaceYN != null && (
                          <li>
                            Fireplace:{" "}
                            <strong>{String(propertyData.fireplaceYN)}</strong>
                          </li>
                        )}

                        {propertyData?.fireplacesTotal && (
                          <li>
                            Fireplace Total:{" "}
                            <strong> {propertyData.fireplacesTotal}</strong>
                          </li>
                        )}

                        {propertyData?.fireplaceFeatures?.length > 0 && (
                          <li>
                            Fireplace Features:{" "}
                            <strong>
                              {propertyData.fireplaceFeatures.join(", ")}
                            </strong>
                          </li>
                        )}
                      </ul>

                      {/* 5. Building Details */}
                      <h5>5. Building & Construction Details</h5>
                      <ul className="custom-list">
                        {propertyData?.buildingAreaTotal && (
                          <li>
                            Building Area:{" "}
                            <strong> {propertyData.buildingAreaTotal}</strong>
                          </li>
                        )}

                        {propertyData?.buildingAreaUnits && (
                          <li>
                            Building Area Units:{" "}
                            <strong> {propertyData.buildingAreaUnits}</strong>
                          </li>
                        )}

                        {propertyData?.buildingFeatures?.length > 0 && (
                          <li>
                            Building Features:{" "}
                            <strong>
                              {propertyData.buildingFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.constructionMaterials?.length > 0 && (
                          <li>
                            Construction Materials:{" "}
                            <strong>
                              {propertyData.constructionMaterials.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.foundationDetails?.length > 0 && (
                          <li>
                            Foundation Details:{" "}
                            <strong>
                              {propertyData.foundationDetails.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.exteriorFeatures?.length > 0 && (
                          <li>
                            Exterior Features:{" "}
                            <strong>
                              {propertyData.exteriorFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.roof?.length > 0 && (
                          <li>
                            Roof:{" "}
                            <strong> {propertyData.roof.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.accessibilityFeatures?.length > 0 && (
                          <li>
                            Accessibility Features:{" "}
                            <strong>
                              {propertyData.accessibilityFeatures.join(", ")}
                            </strong>
                          </li>
                        )}
                      </ul>

                      {/* 6. Lot & Land */}
                      <h5>6. Lot & Land Information</h5>
                      <ul className="custom-list">
                        {propertyData?.lotSizeArea && (
                          <li>
                            Lot Size Area:{" "}
                            <strong>{propertyData.lotSizeArea}</strong>
                          </li>
                        )}

                        {propertyData?.lotSizeDimensions && (
                          <li>
                            Lot Size Dimensions:{" "}
                            <strong>{propertyData.lotSizeDimensions}</strong>
                          </li>
                        )}

                        {propertyData?.lotSizeUnits && (
                          <li>
                            Lot Size Units:{" "}
                            <strong> {propertyData.lotSizeUnits}</strong>
                          </li>
                        )}

                        {propertyData?.lotFeatures?.length > 0 && (
                          <li>
                            Lot Features:{" "}
                            <strong>
                              {" "}
                              {propertyData.lotFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.fencing?.length > 0 && (
                          <li>
                            Fencing Available:{" "}
                            <strong> {propertyData.fencing.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.frontageLengthNumeric && (
                          <li>
                            Frontage(Front Length):{" "}
                            <strong>
                              {propertyData.frontageLengthNumeric}
                            </strong>
                          </li>
                        )}

                        {propertyData?.frontageLengthNumericUnits && (
                          <li>
                            Frontage(Front Length) Unit:{" "}
                            <strong>
                              {propertyData.frontageLengthNumericUnits}
                            </strong>
                          </li>
                        )}

                        {propertyData?.waterfrontFeatures?.length > 0 && (
                          <li>
                            Waterfront Features:{" "}
                            <strong>
                              {propertyData.waterfrontFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.waterBodyName && (
                          <li>
                            Water Body Name:{" "}
                            <strong> {propertyData.waterBodyName}</strong>
                          </li>
                        )}

                        {propertyData?.roadSurfaceType?.length > 0 && (
                          <li>
                            Road Surface Type:{" "}
                            <strong>
                              {propertyData.roaddSurfaceType?.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.irrigationSource?.length > 0 && (
                          <li>
                            Irrigation Source:{" "}
                            <strong>
                              {propertyData.irrigationSource.join(", ")}
                            </strong>
                          </li>
                        )}
                      </ul>

                      {/* 7. Utilities */}
                      <h5>7. Utilities & Systems</h5>
                      <ul className="custom-list">
                        {propertyData?.waterSource?.length > 0 && (
                          <li>
                            Water Source:{" "}
                            <strong>
                              {propertyData.waterSource.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.sewer?.length > 0 && (
                          <li>
                            Sewerage Type:{" "}
                            <strong> {propertyData.sewer.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.electric?.length > 0 && (
                          <li>
                            Electric Type:{" "}
                            <strong> {propertyData.electric.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.heating?.length > 0 && (
                          <li>
                            Heating:{" "}
                            <strong> {propertyData.heating.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.cooling?.length > 0 && (
                          <li>
                            Cooling:{" "}
                            <strong> {propertyData.cooling.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.utilities?.length > 0 && (
                          <li>
                            Utilities Available:{" "}
                            <strong>{propertyData.utilities.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.otherEquipment?.length > 0 && (
                          <li>
                            Other Equipment:{" "}
                            <strong>
                              {propertyData.otherEquipment.join(", ")}
                            </strong>
                          </li>
                        )}
                      </ul>

                      {/* 8. Community */}
                      <h5>8. Community & Neighborhood</h5>
                      <ul className="custom-list">
                        {propertyData?.communityFeatures?.length > 0 && (
                          <li>
                            Community Features:{" "}
                            <strong>
                              {propertyData.communityFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.possibleUse?.length > 0 && (
                          <li>
                            Possible Use:{" "}
                            <strong>
                              {propertyData.possibleUse.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.currentUse?.length > 0 && (
                          <li>
                            Current Use:{" "}
                            <strong>
                              {" "}
                              {propertyData.currentUse.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.anchorsCoTenants && (
                          <li>
                            Anchors Co Tenants:{" "}
                            <strong> {propertyData.anchorsCoTenants}</strong>
                          </li>
                        )}
                      </ul>

                      {/* 9. Parking */}
                      <h5>9. Parking & Garage</h5>
                      <ul className="custom-list">
                        {propertyData?.parkingFeatures?.length > 0 && (
                          <li>
                            Parking:{" "}
                            <strong>
                              {propertyData.parkingFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.parkingTotal && (
                          <li>
                            Total Parking Available:{" "}
                            <strong>{propertyData.parkingTotal}</strong>
                          </li>
                        )}
                      </ul>

                      {/* 10. HOA */}
                      <h5>10. Association (HOA) Details</h5>
                      <ul className="custom-list">
                        {propertyData?.associationFee && (
                          <li>
                            Association Fee:{" "}
                            <strong> {propertyData.associationFee}</strong>
                          </li>
                        )}

                        {propertyData?.associationFeeFrequency && (
                          <li>
                            Association Fee Frequency:{" "}
                            <strong>
                              {propertyData.associationFeeFrequency}
                            </strong>
                          </li>
                        )}

                        {propertyData?.associationName && (
                          <li>
                            Association Name:{" "}
                            <strong> {propertyData.associationName}</strong>
                          </li>
                        )}

                        {propertyData?.associationFeeIncludes?.length > 0 && (
                          <li>
                            Association Fee Includes:{" "}
                            <strong>
                              {propertyData.associationFeeIncludes.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.listAOR && (
                          <li>
                            ListAOR: <strong> {propertyData.listAOR}</strong>
                          </li>
                        )}

                        {propertyData?.listAORKey && (
                          <li>
                            ListAORKey:{" "}
                            <strong>{propertyData.listAORKey}</strong>
                          </li>
                        )}
                      </ul>

                      {/* 11. Agent Info */}
                      <h5>11. Listing & Agent Information</h5>
                      <ul className="custom-list">
                        {/* {propertyData?.listingId && (
                          <li>
                            ListingId:{" "}
                            <strong> {propertyData.listingId}</strong>
                          </li>
                        )} */}

                        {propertyData?.listingURL && (
                          <li>
                            ListingURL:{" "}
                            <strong>{propertyData.listingURL}</strong>
                          </li>
                        )}

                        {propertyData?.originatingSystemName && (
                          <li>
                            OriginatingSystemName:{" "}
                            <strong>
                              {propertyData.originatingSystemName}
                            </strong>
                          </li>
                        )}

                        {propertyData?.listOfficeKey && (
                          <li>
                            ListOfficeKey:{" "}
                            <strong> {propertyData.listOfficeKey}</strong>
                          </li>
                        )}

                        {propertyData?.listAgentKey && (
                          <li>
                            ListAgentKey:{" "}
                            <strong> {propertyData.listAgentKey}</strong>
                          </li>
                        )}

                        {propertyData?.coListOfficeKey && (
                          <li>
                            CoListOfficeKey:{" "}
                            <strong> {propertyData.coListOfficeKey}</strong>
                          </li>
                        )}

                        {propertyData?.coListAgentKey && (
                          <li>
                            CoListAgentKey:{" "}
                            <strong> {propertyData.coListAgentKey}</strong>
                          </li>
                        )}

                        {propertyData?.internetEntireListingDisplayYN !==
                          undefined && (
                          <li>
                            InternetEntireListingDisplayYN:{" "}
                            <strong>
                              {String(
                                propertyData.internetEntireListingDisplayYN
                              )}
                            </strong>
                          </li>
                        )}

                        {propertyData?.internetAddressDisplayYN !==
                          undefined && (
                          <li>
                            InternetAddressDisplayYN:{" "}
                            <strong>
                              {String(propertyData.internetAddressDisplayYN)}
                            </strong>
                          </li>
                        )}

                        {propertyData?.originalEntryTimestamp && (
                          <li>
                            OriginalEntryTimestamp:{" "}
                            <strong>
                              {propertyData.originalEntryTimestamp}
                            </strong>
                          </li>
                        )}

                        {propertyData?.modificationTimestamp && (
                          <li>
                            ModificationTimestamp:{" "}
                            <strong>
                              {propertyData.modificationTimestamp}
                            </strong>
                          </li>
                        )}

                        {propertyData?.statusChangeTimestamp && (
                          <li>
                            StatusChangeTimestamp:{" "}
                            <strong>
                              {propertyData.statusChangeTimestamp}
                            </strong>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side */}
            <div className="col-md-4">
              {propeId &&
                propeId !== "null" &&
                propertyData?.requested === false && (
                  <>
                    <div className="auction-cardpro 2 kliod">
                      <div className="timebtn klio">
                        {/* <h5>Offer ENDS IN</h5> */}
                        <Countdown
                          start={
                            propertyData.biddingDetails?.bidingStartDateTime
                          }
                          end={propertyData.biddingDetails?.bidingEndDateTime}
                        />
                      </div>
                    </div>

                    {/* --- Section 1 --- */}
                    <div className="auction-cardpro">
                      <h4>Desired Property Value</h4>
                      <h2 className="pricepro">
                        ${propertyData.listPrice || "NA"}
                      </h2>
                      {/* <p className="start-text">Starting Bid</p> */}
                      <button
                        className="place-bid mko"
                        onClick={async () => {
                          const token = localStorage.getItem("token");

                          // 🔹 Step A: If not logged in → block + show login popup
                          if (!token) {
                            Swal.fire({
                              icon: "warning",
                              title: "Login Required",
                              text: "Please login to send a request!",
                              confirmButtonColor: "#3085d6",
                              confirmButtonText: "OK",
                            }).then((result) => {
                              if (result.isConfirmed) {
                                window.open("/login", "_blank"); // 👉 Opens login page in new tab
                              }
                            });

                            return; // ❗ stop execution
                          }

                          try {
                            // 🔹 Step 1: Check deposit status
                            const res = await axios.get(
                              `${baseUrl}/paypal/deposit?propertyId=${propertyId}&userId=${userId}`
                            );

                            if (res.data.status === 200) {
                              if (res.data.data === false) {
                                // 🔹 Step 2: Redirect if deposit not done
                                window.location.href = `/placebid?id=${propertyId}&propeId=${propeId}`;
                              } else if (res.data.data === true) {
                                // 🔹 Step 3: If deposit done → send property request
                                const sendRes = await axios.put(
                                  `${baseUrl}/property-request/send?userId=${userId}&propertyId=${propertyId}`
                                );

                                if (sendRes.data.status === 200) {
                                  Swal.fire({
                                    icon: "success",
                                    title: "Request Sent!",
                                    text: "Your property request was sent successfully.",
                                    confirmButtonColor: "#3085d6",
                                  }).then(() => {
                                    window.location.reload();
                                  });
                                } else {
                                  Swal.fire({
                                    icon: "warning",
                                    title: "Failed!",
                                    text: "Failed to send property request.",
                                    confirmButtonColor: "#d33",
                                  });
                                }
                              }
                            } else {
                              alert("Failed to check deposit status.");
                            }
                          } catch (err) {
                            console.error(err);
                            alert("Something went wrong.");
                          }
                        }}
                      >
                        Send Request
                      </button>
                    </div>

                    {/* --- Section 2 --- */}
                    <div className="auction-cardpro 2">
                      {/*Corrected Property Value Logic */}
                      <h2 className="pricepro">
                        {(() => {
                          // if socket gives us amount → use it directly
                          if (liveBid) {
                            return `$${Number(liveBid).toLocaleString()}`;
                          }

                          const details = propertyData.biddingDetails;

                          if (!details) {
                            // No Offer details → show desiredPropertyValue
                            return `$${
                              propertyData.desiredPropertyValue || "N/A"
                            }`;
                          }

                          // Extract values
                          const { currenntAuctionAmount, bidStartingValue } =
                            details;

                          // If currenntAuctionAmount is not null → show it
                          if (
                            currenntAuctionAmount !== null &&
                            currenntAuctionAmount !== undefined
                          ) {
                            return `$${Number(
                              currenntAuctionAmount
                            ).toLocaleString()}`;
                          }

                          // Else → show bidStartingValue
                          if (
                            bidStartingValue !== null &&
                            bidStartingValue !== undefined
                          ) {
                            return `$${Number(
                              bidStartingValue
                            ).toLocaleString()}`;
                          }

                          // Fallback
                          return "$N/A";
                        })()}
                      </h2>

                      <p className="start-text">Starting Offers</p>

                      {/* --- Offer logic --- */}
                      {propertyData.biddingDetails &&
                        (() => {
                          const { isBidEnd, bidingStartDateTime } =
                            propertyData.biddingDetails;
                          const currentTime = new Date();
                          const startTime = new Date(bidingStartDateTime);

                          // (a) If bid has ended
                          if (isBidEnd) {
                            return null;
                          }

                          // (b) If bid start time == current time (to nearest minute)
                          const sameTime =
                            Math.abs(
                              currentTime.getTime() - startTime.getTime()
                            ) < 60000;

                          if (sameTime) {
                            // Show only Request for Bid
                            return (
                              <button className="place-bid">
                                Request For Bid
                              </button>
                            );
                          }

                          // (c) Otherwise show place bid and +/-
                          return (
                            <div className="bidflex">
                              <div className="bid-controls">
                                <button
                                  onClick={() =>
                                    setBid((prev) => {
                                      // Actual (minimum allowed) value
                                      const minBid =
                                        propertyData?.biddingDetails
                                          ?.currenntAuctionAmount ??
                                        propertyData?.biddingDetails
                                          ?.bidStartingValue ??
                                        propertyData?.desiredPropertyValue ??
                                        0;

                                      // Prevent bid going below actual price
                                      return prev - 1000 >= minBid
                                        ? prev - 1000
                                        : prev;
                                    })
                                  }
                                >
                                  -
                                </button>

                                {/* <span>${bid.toLocaleString()}</span> */}
                                {/* <span>${Number(liveBid).toLocaleString()}</span> */}
                                <span>
                                  $
                                  {(() => {
                                    if (liveBid && liveBid > bid)
                                      return Number(liveBid).toLocaleString();
                                    if (bid)
                                      return Number(bid).toLocaleString();
                                    return "0";
                                  })()}
                                </span>

                                <button
                                  onClick={() => {
                                    // Increase by 1000 (or any step)
                                    setBid((prev) => prev + 1000);
                                  }}
                                >
                                  +
                                </button>
                              </div>
                              <button
                                className="place-bid"
                                onClick={async () => {
                                  const token = localStorage.getItem("token");
                                  // Step 1: If not logged in, block immediately
                                  if (!token) {
                                    Swal.fire({
                                      icon: "warning",
                                      title: "Login Required",
                                      text: "Please login to place a bid!",
                                      confirmButtonColor: "#3085d6",
                                      confirmButtonText: "OK",
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        window.open("/login", "_blank"); // 👉 Opens login in new tab
                                      }
                                    });

                                    return;
                                  }
                                  try {
                                    const details = propertyData.biddingDetails;
                                    const minBid =
                                      details?.currenntAuctionAmount ??
                                      details?.bidStartingValue ??
                                      propertyData.desiredPropertyValue ??
                                      0;

                                    const currentPrice =
                                      liveBid && liveBid > minBid
                                        ? liveBid
                                        : minBid;

                                    // Step 2: Prevent Offer lower amount
                                    if (bid <= currentPrice) {
                                      Swal.fire({
                                        icon: "warning",
                                        title: "Increase Your Bid",
                                        text: `Please increase your bid amount above $${Number(
                                          currentPrice
                                        ).toLocaleString()}.`,
                                      });
                                      return;
                                    }

                                    // Step 3: Deposit check before Offer
                                    const res = await axios.get(
                                      `${baseUrl}/paypal/deposit?propertyId=${propertyId}&userId=${userId}`
                                    );

                                    if (res.data.status === 200) {
                                      if (res.data.data === false) {
                                        // Redirect to deposit page
                                        window.location.href = `/placebid?id=${propertyId}&propeId=${propeId}`;
                                      } else {
                                        // Step 4: Proceed with sending bid through WebSocket
                                        const buyerId =
                                          localStorage.getItem("userId");
                                        const propertyIdVal = propertyData.id;
                                        const bidAmount = bid
                                          .toLocaleString()
                                          .replace(/,/g, "");

                                        socketService.sendBid(
                                          propertyIdVal,
                                          bidAmount,
                                          buyerId
                                        );
                                      }
                                    } else {
                                      alert("Failed to check deposit status.");
                                    }
                                  } catch (err) {
                                    console.error(err);
                                    alert(
                                      "Something went wrong while placing the bid."
                                    );
                                  }
                                }}
                              >
                                Place Bid
                              </button>
                            </div>
                          );
                        })()}
                    </div>
                  </>
                )}

              <div className="info-card bhfg">
                <h5>Listed By</h5>
                <div className="kio">
                  <p>
                    <span>Agent</span> : {user?.name || "N/A"}
                  </p>
                  <p>
                    <span>Email</span> : {user?.email || "N/A"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Slider */}
        <div className="container-fluid" id="RecommendedProperties">
          <div className="row">
            <div className="col-md-12">
              <Slider />
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {isPopupOpen && (
        <div className="popup-overlay" onClick={() => setIsPopupOpen(false)}>
          <div
            className="popup-content poioi"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={() => setIsPopupOpen(false)}>
              ✕
            </button>

            {/* Image Counter */}
            <div className="image-counter">
              {popupIndex + 1} / {thumbImages.length}
            </div>

            <div className="popup-slider">
              <button
                className="nav-btn prev"
                onClick={() =>
                  setPopupIndex((prev) =>
                    prev === 0 ? thumbImages.length - 1 : prev - 1
                  )
                }
              >
                ‹
              </button>

              <img
                src={thumbImages[popupIndex]?.imageUrl || placeimg}
                alt={`Popup ${popupIndex + 1}`}
                className="popup-img show"
              />

              <button
                className="nav-btn next"
                onClick={() =>
                  setPopupIndex((prev) =>
                    prev === thumbImages.length - 1 ? 0 : prev + 1
                  )
                }
              >
                ›
              </button>
            </div>

            <div className="popup-thumbs">
              {thumbImages.map((img, index) => (
                <img
                  key={index}
                  src={img?.imageUrl || placeimg}
                  alt={`Thumb ${index + 1}`}
                  className={`thumb-mini ${
                    index === popupIndex ? "active" : ""
                  }`}
                  onClick={() => setPopupIndex(index)}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PropertyDetail;
